class AlertEntity {
    message: string | null;
    delay: number | null;
    onClose: (() => void) | null;
    onOk: (() => void) | null;
    withOk: boolean | null;
    withCancel: boolean | null;
    withInput: boolean | null;
    level: number | null;
    constructor(object: {
        message?: string | null;
        delay?: number | null;
        onClose?: (() => void) | null;
        onOk?: (() => void) | null;
        withOk?: boolean | null;
        withCancel?: boolean | null;
        withInput?: boolean | null;
        level?: number | null;
    }) {
        this.message = object.message ?? '';
        this.delay = object.delay ?? 10;
        this.onClose = object.onClose ?? (() => { });
        this.onOk = object.onOk ?? (() => { });
        this.withOk = object.withOk ?? true;
        this.withCancel = object.withCancel ?? false;
        this.withInput = object.withInput ?? false;
        this.level = object.level ?? 1;
    }

    isEmpty() {
        return this.message == null &&
            this.delay == null &&
            this.onClose == null &&
            this.onOk == null &&
            this.withOk == null &&
            this.withCancel == null &&
            this.withInput == null &&
            this.level == null
    }
}

export { AlertEntity };